import { render, staticRenderFns } from "./Xero.vue?vue&type=template&id=0c429c4a&scoped=true"
import script from "./Xero.vue?vue&type=script&lang=js"
export * from "./Xero.vue?vue&type=script&lang=js"
import style0 from "./Xero.vue?vue&type=style&index=0&id=0c429c4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c429c4a",
  null
  
)

export default component.exports